import React, { forwardRef } from "react";
// import { useTranslation } from "react-i18next";

const ReservationPrint = forwardRef((props, ref) => {
  let { datagridOptions, datagridColumns } = props;

  return (
    <div ref={ref}>
      <style type="text/css" media="print">
        {
          `\
        @page { size: landscape; }\
        
      `
        }
      </style>

      <div style={{ padding: "10px",
        //  marginBottom: "100%"
          }}>
      
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            marginRight: "20px",
            marginLeft: "20px",
            marginBottom: "20px",
            borderTop: "2px solid",
            marginTop: "20px",
          }}
        ></div>

        <div className="pl-2 pr-2">
          {datagridColumns?.length > 0 && (
            <table
              // id={"flash-head"}
              style={{
                tableLayout: "fixed",
                width: "100%",
                // border: "1px solid",
                marginTop: "20px",
                borderCollapse: "separate",
                borderSpacing: "0 1em",
              }}
            >
              <thead className="report-header" style={{ textAlign: "left" }}>
                <tr id="mb-1" style={{ borderBottom: "2px solid" }}>
                  {datagridColumns?.map((item, i) => {
                    return (
                      <React.Fragment key={i}>
                        {item?.headerName !== "Chat" && item?.headerName !== "Actions" && (
                          <th>
                            <u
                              id="font-600"
                              // className="mx-1"
                              style={{
                                fontSize: "14px",
                                paddingLeft: "2px",
                                textAlign: "left",
                                display: "inline-block",
                                maxWidth: "70px", // Adjust based on your layout
                                wordWrap: "break-word", // Breaks long words if needed
                                overflowWrap: "break-word", // Ensures text breaks properly
                                whiteSpace: "normal", // Allows multi-line wrapping
                              }}
                            >
                              {item?.headerName}
                            </u>
                          </th>
                        )}
                      </React.Fragment>
                    );
                  })}
                </tr>
              </thead>
              <tbody className="report-content">
                {datagridOptions?.rows?.map((item, i) => {
                  return (
                    <tr key={i} id="mb-1">
                      {datagridColumns?.map((cItem, c) => {
                        return (
                            cItem?.headerName !== "Chat" && cItem?.headerName !== "Actions" && (<td
                            key={cItem?.field}
                            style={{
                              fontSize: "15px",
                              textAlign: "left",
                              wordWrap: "break-word",
                              whiteSpace: "pre-wrap",
                              paddingLeft: "2px",
                            }}
                          >
                            {item[cItem?.field]}
                          </td>)
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              // marginRight: "20px",
              // marginLeft: "20px",
              marginBottom: "20px",
              borderTop: "2px solid",
              marginTop: "20px",
            }}
          ></div>
        </div>
      </div>
    </div>
  );
});

export default ReservationPrint;
